class AddressesWrapper extends HTMLElement {
  constructor() {
    super();

    const addressToggleButtons = this.querySelectorAll("[data-address-toggle]");
    const addressesContent = this.querySelector("#addresses-content");

    const showAddress = (addressForm) => {
      addressForm.classList.add("open");
      addressForm.style.display = "block";
      if (addressesContent) {
        addressesContent.style.display = "none";
      }
    };

    const closeAddress = (addressForm) => {
      addressForm.classList.remove("open");
      addressForm.style.display = "none";
      if (addressesContent) {
        addressesContent.style.display = "block";
      }
    };

    addressToggleButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const id = button.getAttribute("aria-controls");
        const addressForm =
          document.getElementById(id) ?? button.closest("[data-address-form]");

        if (addressForm.getAttribute("open") === "") {
          closeAddress(addressForm);
        } else {
          showAddress(addressForm);
        }
      });
    });
  }
}

customElements.define("addresses-wrapper", AddressesWrapper);
